import Image from 'next/image';
import { FC, ReactNode } from 'react';
import { FileUploader } from 'react-drag-drop-files';

interface IFileUploadProps {
  type: string[];
  files: File[];
  setFiles: (files: File[]) => void;
  customChildren?: ReactNode;
  disabled?: boolean;
  hideFileList?: boolean;
}

const FileUpload: FC<IFileUploadProps> = ({
  type,
  files,
  setFiles,
  customChildren,
  disabled = false,
  hideFileList = false,
}: IFileUploadProps) => {
  const handleChange = (files: File | File[]) => {
    const fileArray = Array.isArray(files) ? files : [files];
    setFiles(fileArray);
  };

  return (
    <>
      <FileUploader handleChange={handleChange} name='files' types={type} multiple disabled={disabled}>
        <div>
          {customChildren ?? (
            <div
              className='flex h-[80px] min-w-[300px] px-[12px] py-[10px] justify-center items-center 
                              marker:gap-[10px] align-self-stretch rounded-md border-dashed border-2 
                            border-gray-300 bg-[#F8F9FA] shadow-md md:w-[255px] w-full cursor-pointer hover:border-gray-600 group '
            >
              <p className='text-14 first-line:text-gray-500 font-inter text-base font-normal leading-5 group-hover:first-line:text-gray-700'>
                Upload or drag files here
              </p>
            </div>
          )}
        </div>
      </FileUploader>
      {!hideFileList && files.length > 0 && (
        <div className='flex flex-wrap gap-2 mt-4'>
          {[...files].map((file: File, key: number) => {
            return (
              <div key={key} className='flex justify-center items-center gap-[11px]'>
                <Image
                  src='/images/solar_file-bold.png'
                  className='w-[58px] h-[58px]'
                  alt='File icon'
                  width={58}
                  height={58}
                />
                <div className='flex flex-col items-start gap-[5px] max-w-[190px]'>
                  <p className='text-14 text-black font-inter text-base font-normal leading-5'>
                    {file.name}
                  </p>
                  <p className='text-14 text-black/50 font-inter text-base font-normal leading-5'></p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default FileUpload;
